import { environment } from '@lla-platform/core/core-util'

export const TIRES_API_URL = {
  tiresSummary: `${environment.apiUrl}/tires/summary-by-program`,
  exportTiresSummary: `${environment.apiUrl}/tires/summary-by-program/export`,
  tiresSummaryTrend: `${environment.apiUrl}/tires/summary-by-program/trend`,
  tiresByLevelSummary: `${environment.apiUrl}/tires/summary-by-level`,
  exportTiresByLevelSummary: `${environment.apiUrl}/tires/summary-by-level/export`,
  tiresByStockableSummary: `${environment.apiUrl}/tires/summary-by-stockable`,
  exportTiresByStockableSummary: `${environment.apiUrl}/tires/summary-by-stockable/export`,
  tiresByRotationSummary: `${environment.apiUrl}/tires/summary-by-tire-rotation`,
  exportTiresByRotationSummary: `${environment.apiUrl}/tires/summary-by-tire-rotation/export`,
  tiresByPaymentSummary: `${environment.apiUrl}/tires/summary-by-tire-payment`,
  exportTiresByPaymentSummary: `${environment.apiUrl}/tires/summary-by-tire-payment/export`,

  tiresList: `${environment.apiUrl}/tires/filters/tires`,
  exportTiresList: `${environment.apiUrl}/tires/filters/tires/export`,
  updateTire: (itemId: string) => `${environment.apiUrl}/tires/update-tire/spl/${itemId}`,
  lostTire: `${environment.apiUrl}/tires/form`,
  lostTiresList: `${environment.apiUrl}/tires/filters/lost-tires`,
  exportLostTiresList: `${environment.apiUrl}/tires/filters/lost-tires/export`,
  getTireLevelsExplain: `${environment.apiUrl}/tires/levels`,

  tireInventorySummary: `${environment.apiUrl}/tires/inventory-summary`,
  exportTireInventorySummary: `${environment.apiUrl}/tires/inventory-summary/export`,
  tireInventoryList: `${environment.apiUrl}/tires/filters/inventory`,
  tireInventoryListUsaf: `${environment.apiUrl}/tires/usaf/inventory`,
  tireUsafStockCheck: `${environment.apiUrl}/tires/filters/usaf/stock-check`,
  tireUsafSubmitOrder: `${environment.apiUrl}/tires/usaf/orders`,
  tireUsafOrderHistory: `${environment.apiUrl}/tires/usaf/orders`,
  tireUsafRefreshOrderStatuses: `${environment.apiUrl}/tires/usaf/orders/refresh-status`,
  tireUsafOrderDetail: (orderId: string) => `${environment.apiUrl}/tires/usaf/orders/${orderId}`,
  tireUsafOrdersList: `${environment.apiUrl}/tires/filters/usaf/orders`,
  tireUsafOrdersOverview: `${environment.apiUrl}/tires/filters/usaf/orders/overview`,
  tireUsafOrderLinesList: `${environment.apiUrl}/tires/filters/usaf/order-lines`,
  tireUsafInvoicesList: `${environment.apiUrl}/tires/filters/usaf/invoices`,
  tireUsafAutoOrderAttemptsList: `${environment.apiUrl}/tires/filters/usaf/auto-order-attempts`,
  tireUsafAutoOrderOverview: `${environment.apiUrl}/tires/filters/usaf/auto-order-attempts/overview`,
  tireUsafLeftoversList: `${environment.apiUrl}/tires/filters/usaf/leftovers`,
  tireUsafOverdueOrdersList: `${environment.apiUrl}/tires/filters/usaf/overdue-orders`,
  tireUsafRefillLocations: `${environment.apiUrl}/tires/usaf/refill/locations`,
  tireUsafRefillPlan: `${environment.apiUrl}/tires/usaf/refill/plan`,
  tireUsafRefillSubmit: `${environment.apiUrl}/tires/usaf/refill`,
  exportTireInventoryList: `${environment.apiUrl}/tires/filters/inventory/export`
}
